import React from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import cn from 'classnames';

import { Icon } from 'components';
import globalMsg from 'messages';
import { State } from 'types';
import { toggleOddHistory } from '../../actions';
import { selectIsOddHistoryEnabled } from '../../selectors';

import changeHistory from 'assets/svg/change-history.svg';
import './toggleHistory.scss';

const ToggleHistory: React.FC = () => {
    const isEnable = useSelector((s: State) => selectIsOddHistoryEnabled(s));
    const dispatch = useDispatch();
    const { formatMessage } = useIntl();

    const changeStatus = () => {
        dispatch(toggleOddHistory({ isEnable }));
    };

    const title = formatMessage(globalMsg.ChangeHistory);

    return (
        <div styleName="container" title={title} onClick={changeStatus}>
            <Icon
                styleName={cn('icon', {
                    ['is-enable']: isEnable,
                })}
                glyph={changeHistory}
            />
        </div>
    );
};

export default ToggleHistory;
